import React, { useContext, useEffect, useState } from "react";
import * as S from "./DepositosStyle";
import { formatDate } from "../ASSETS/assets";
import PaginaContrato from "../PaginaDoContrato/PaginaContrato";
import { AuthContext } from "../../Context/AuthContext";
import Loading from "../Loader";
import { useNavigate } from "react-router-dom";
import { FaPlus, FaSearch } from "react-icons/fa";
import { useMessage } from "../../Context/MessageContext";
import NewContract from "./NewContract/NewContract";
import { contractAdminService } from "../../Services/contractAdminService";
import { auditService } from "../../Services/auditService";
import VerVenda from "./VerVenda"; // Importando do arquivo index.js ou VerVenda.js na mesma pasta
import NewContractWithdraw from "./NewContractWithdraw/NewContractWithdraw";
import ModalRecibo from "./ModalRecibo/ModalRecibo";

export default function Depositos() {
  const { pendingPurchases, getPendingPurchases, totalPendingPurchases } =
    useContext(AuthContext);
  const { showMessage } = useMessage();
  const navigate = useNavigate();

  const [search, setSearch] = useState("");
  const [isRepurchaseFilter, setIsRepurchaseFilter] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [orderFilter, setOrderFilter] = useState("date_desc");
  const [load, setLoad] = useState(false);
  const [itemsPerPage] = useState(10);

  // Estados dos Modais
  const [selectedContract, setSelectedContract] = useState(null);
  const [isNewContractOpen, setIsNewContractOpen] = useState(false);
  const [viewSaleId, setViewSaleId] = useState(null); // Inicializa como null
  const [isNewWithdrawOpen, setIsNewWithdrawOpen] = useState(false);
  const [modalRecibo, setModalRecibo] = useState(null);
  const [removeReceiptModal, setRemoveReceiptModal] = useState(null); // contractId
  const [removeReceiptConfirm, setRemoveReceiptConfirm] = useState("");

  useEffect(() => {
    fetchContracts(1);
  }, [isRepurchaseFilter]);

  const fetchContracts = async (page, customOrder = orderFilter) => {
    setLoad(true);
    try {
      console.log("Buscando página:", page);
      await getPendingPurchases(page, itemsPerPage, customOrder, search, isRepurchaseFilter);
      setCurrentPage(page);
    } catch (e) {
      console.log(e);
      showMessage("Erro ao carregar os depósitos.", "error");
    }
    setLoad(false);
  };

  const handleSearch = () => {
    fetchContracts(1);
  };

  const handleOrderChange = (e) => {
    const newOrder = e.target.value;
    setOrderFilter(newOrder);
    fetchContracts(1, newOrder);
  };

  const handleIsRepurchaseChange = (e) => {
    setIsRepurchaseFilter(e.target.value);
  };

  const handleEditStatus = async (id, clientName, newStatus) => {
    setLoad(true);
    try {
      await contractAdminService.updateContractStatus(id, newStatus);
      const action = newStatus === 3 ? "negado" : "aceito";
      showMessage(`Contrato ${action} com sucesso!`, "success");

      fetchContracts(currentPage);
      await auditService.registerContractApproval(
        id,
        clientName,
        newStatus != "3"
      );
    } catch (err) {
      console.error("Erro ao atualizar status:", err);
      showMessage("Ocorreu um erro ao atualizar o status.", "error");
    } finally {
      setLoad(false);
    }
  };

  const handleApproveRepurchase = async (id, clientName, approved) => {
    setLoad(true);
    try {
      await contractAdminService.approveRepurchase(id, approved);
      const action = approved ? "aceita" : "negada";
      showMessage(`Recompra ${action} com sucesso!`, "success");

      fetchContracts(currentPage);
      await auditService.registerContractApproval(id, clientName, approved);
    } catch (err) {
      console.error("Erro ao processar recompra:", err);
      showMessage("Ocorreu um erro ao processar a recompra.", "error");
    } finally {
      setLoad(false);
    }
  };

  const handleRemoveReceipt = async () => {
    if (removeReceiptConfirm !== "CONFIRMAR") return;
    setLoad(true);
    try {
      await contractAdminService.removeReceipt(removeReceiptModal);
      showMessage("Recibo removido com sucesso!", "success");
      setRemoveReceiptModal(null);
      setRemoveReceiptConfirm("");
      fetchContracts(currentPage);
    } catch (err) {
      showMessage("Erro ao remover o recibo.", "error");
    } finally {
      setLoad(false);
    }
  };

  const totalPages = Math.ceil(totalPendingPurchases / itemsPerPage);


  return (
    <S.ContratosContainer>
      <Loading load={load} />

      {/* Modal: Detalhes do Contrato */}
      {selectedContract != null && (
        <PaginaContrato
          contratoData={selectedContract}
          handleClose={() => setSelectedContract(null)}
        />
      )}

      {/* Modal: Novo Contrato */}
      {isNewContractOpen && (
        <NewContract handleClose={() => setIsNewContractOpen(false)} />
      )}

      {isNewWithdrawOpen && (
        <NewContractWithdraw handleClose={() => setIsNewWithdrawOpen(false)} />
      )}

      {/* Modal: Ver Venda */}
      {viewSaleId !== null && (
        <VerVenda saleId={viewSaleId} handleClose={() => setViewSaleId(null)} />
      )}

      {modalRecibo && (
        <ModalRecibo url={modalRecibo} onClose={() => setModalRecibo(null)} />
      )}

      {removeReceiptModal && (
        <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(0,0,0,0.85)", backdropFilter: "blur(6px)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 3000 }}
          onClick={() => { setRemoveReceiptModal(null); setRemoveReceiptConfirm(""); }}
        >
          <div style={{ background: "#1e1e1e", borderRadius: "16px", padding: "36px", width: "90%", maxWidth: "440px", border: "1px solid rgba(231,76,60,0.3)", boxShadow: "0 20px 50px rgba(0,0,0,0.5)" }}
            onClick={(e) => e.stopPropagation()}
          >
            <h3 style={{ color: "#e74c3c", margin: "0 0 10px 0", fontSize: "1.1rem" }}>Remover Recibo</h3>
            <p style={{ color: "#aaa", fontSize: "0.9rem", margin: "0 0 24px 0", lineHeight: "1.6" }}>
              Esta ação removerá o recibo do contrato <strong style={{ color: "#fff" }}>#{removeReceiptModal}</strong>. Digite <strong style={{ color: "#fff" }}>CONFIRMAR</strong> para prosseguir.
            </p>
            <input
              value={removeReceiptConfirm}
              onChange={(e) => setRemoveReceiptConfirm(e.target.value)}
              placeholder="CONFIRMAR"
              style={{ width: "100%", height: "46px", borderRadius: "10px", border: "1px solid rgba(255,255,255,0.1)", background: "rgba(0,0,0,0.3)", color: "#fff", padding: "0 14px", fontSize: "1rem", boxSizing: "border-box", marginBottom: "16px" }}
            />
            <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
              <button onClick={() => { setRemoveReceiptModal(null); setRemoveReceiptConfirm(""); }}
                style={{ padding: "10px 20px", borderRadius: "10px", border: "1px solid rgba(255,255,255,0.1)", background: "transparent", color: "#aaa", cursor: "pointer", fontWeight: "600" }}>
                Cancelar
              </button>
              <button onClick={handleRemoveReceipt} disabled={removeReceiptConfirm !== "CONFIRMAR"}
                style={{ padding: "10px 24px", borderRadius: "10px", border: "none", background: removeReceiptConfirm === "CONFIRMAR" ? "#e74c3c" : "#555", color: "#fff", cursor: removeReceiptConfirm === "CONFIRMAR" ? "pointer" : "not-allowed", fontWeight: "700", transition: "background 0.2s" }}>
                Remover
              </button>
            </div>
          </div>
        </div>
      )}

      <S.ContentBox>
        <S.Header>
          <S.ContractsTitle>Validar Depósitos Pendentes</S.ContractsTitle>
          <S.Divisor>
            <S.CreateButton onClick={() => setIsNewContractOpen(true)}>
              <FaPlus /> Novo Contrato
            </S.CreateButton>
            <S.CreateButtonWithdraw onClick={() => setIsNewWithdrawOpen(true)}>
              <FaPlus /> Novo Contrato - Reversão de Saque
            </S.CreateButtonWithdraw>
          </S.Divisor>
        </S.Header>

        <S.SearchAreaContent>
          <S.SearchClient>
            <span className="title">Pesquisar por Cliente</span>
            <div className="box">
              <input
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="NOME OU CPF"
                onKeyPress={(e) => e.key === "Enter" && handleSearch()}
              />
              <button onClick={handleSearch}>
                <FaSearch />
              </button>
            </div>
          </S.SearchClient>
          <S.FiltersRow>
            <S.FilterDiv>
              <h4>Ordem</h4>
              <select value={orderFilter} onChange={handleOrderChange}>
                <option value="date_desc">Mais Recentes</option>
                <option value="date_asc">Mais Antigos</option>
                <option value="value_desc">Maior Valor</option>
                <option value="value_asc">Menor Valor</option>
              </select>
            </S.FilterDiv>
            <S.FilterDiv>
              <h4>Recompra</h4>
              <select value={isRepurchaseFilter} onChange={handleIsRepurchaseChange}>
                <option value="">TODOS</option>
                <option value="true">SIM</option>
                <option value="false">NÃO</option>
              </select>
            </S.FilterDiv>
          </S.FiltersRow>
        </S.SearchAreaContent>

        <S.TableContainer>
          <S.Table>
            <S.TableHeader>
              <S.TableRow>
                <S.TableHeaderCell>ID</S.TableHeaderCell>
                <S.TableHeaderCell>Data</S.TableHeaderCell>
                <S.TableHeaderCell>Cliente</S.TableHeaderCell>
                <S.TableHeaderCell>CPF</S.TableHeaderCell>
                <S.TableHeaderCell>Valor</S.TableHeaderCell>
                <S.TableHeaderCell>Campanha</S.TableHeaderCell>
                <S.TableHeaderCell>É Recompra?</S.TableHeaderCell>
                <S.TableHeaderCell>Detalhes / Venda</S.TableHeaderCell>
                <S.TableHeaderCell>Recibo</S.TableHeaderCell>
                <S.TableHeaderCell>Criado Por</S.TableHeaderCell>
                <S.TableHeaderCell>Ações</S.TableHeaderCell>
              </S.TableRow>
            </S.TableHeader>
            <S.TableBody>
              {pendingPurchases &&
                pendingPurchases.map((ctr) => (
                  <S.TableRow key={ctr.contract.id}>
                    <S.TableCell>{ctr.contract.id}</S.TableCell>
                    <S.TableCell>
                      {formatDate(ctr.contract.dateCreated)}
                    </S.TableCell>
                    <S.TableCell>{ctr.clientName.toUpperCase()}</S.TableCell>
                    <S.TableCell>{ctr.clientCpfCnpj}</S.TableCell>
                    <S.TableCell>
                      R$ {ctr.contract.totalPrice?.toFixed(2)}
                    </S.TableCell>

                    <S.TableCell>
                      {ctr.contract.promotionName ? ctr.contract.promotionName : "Não informado"}
                    </S.TableCell>

                    <S.TableCell>
                      {ctr.contract.isRepurchase ? "Sim" : "Não"}
                    </S.TableCell>

                    {/* Coluna com os dois botões lado a lado */}
                    <S.TableCell>
                      <S.ButtonGroup>
                        {/* Botão para abrir o Contrato */}
                        <S.ContractButton
                          onClick={() => setSelectedContract(ctr)}
                        >
                          Ver Contrato
                        </S.ContractButton>

                        {/* Botão para abrir a Venda (se existir consultor) */}
                        {ctr.contract.client.consultorId ? (
                          <S.SaleButton
                            onClick={() => setViewSaleId(ctr.contract.id)}
                          >
                            Ver Venda
                          </S.SaleButton>
                        ) : (
                          <span
                            style={{
                              fontSize: "12px",
                              color: "#888",
                              alignSelf: "center",
                            }}
                          >
                            -
                          </span>
                        )}
                      </S.ButtonGroup>
                    </S.TableCell>

                    <S.TableCell>
                      {ctr.contract.receiptUrl ? (
                        <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
                          <button
                            onClick={() => setModalRecibo(ctr.contract.receiptUrl)}
                            style={{ background: "rgba(212, 175, 55, 1)", color: "black", cursor: "pointer", padding: "5px 10px", border: "none", borderRadius: "4px", fontWeight: "bold" }}
                          >
                            Ver Recibo
                          </button>
                          <button
                            onClick={() => { setRemoveReceiptModal(ctr.contract.id); setRemoveReceiptConfirm(""); }}
                            style={{ background: "#c0392b", color: "#fff", cursor: "pointer", padding: "5px 10px", border: "none", borderRadius: "4px", fontWeight: "bold" }}
                          >
                            Remover
                          </button>
                        </div>
                      ) : (
                        <span style={{ color: "#666" }}>Não Anexado</span>
                      )}
                    </S.TableCell>

                    <S.TableCell>
                      {ctr.contract.createdBy ? ctr.contract.createdBy : "Não informado"}
                    </S.TableCell>

                    <S.TableCell>
                      <div className="buttonBox">
                        {ctr.contract.isRepurchase ? (
                          <>
                            <button
                              className="actionBtn"
                              onClick={() =>
                                handleApproveRepurchase(ctr.contract.id, ctr.clientName, false)
                              }
                              style={{ background: "#c0392b" }}
                            >
                              Negar Recompra
                            </button>
                            <button
                              className="actionBtn"
                              onClick={() =>
                                handleApproveRepurchase(ctr.contract.id, ctr.clientName, true)
                              }
                              style={{ background: "#27ae60" }}
                            >
                              Aceitar Recompra
                            </button>
                          </>
                        ) : (
                          <>
                            <button
                              className="actionBtn"
                              onClick={() =>
                                handleEditStatus(ctr.contract.id, ctr.clientName, 3)
                              }
                              style={{ background: "#c0392b" }}
                            >
                              Negar
                            </button>
                            <button
                              className="actionBtn"
                              onClick={() =>
                                handleEditStatus(ctr.contract.id, ctr.clientName, 1)
                              }
                              style={{ background: "#27ae60" }}
                            >
                              Aceitar
                            </button>
                          </>
                        )}
                      </div>
                    </S.TableCell>
                  </S.TableRow>
                ))}
            </S.TableBody>
          </S.Table>
        </S.TableContainer>

        <S.PaginationContainer>
          <S.PaginationButton
            onClick={() => fetchContracts(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Anterior
          </S.PaginationButton>
          <span>
            Página {currentPage} de {totalPages > 0 ? totalPages : 1}
          </span>
          <S.PaginationButton
            onClick={() => fetchContracts(currentPage + 1)}
            disabled={currentPage >= totalPages}
          >
            Próxima
          </S.PaginationButton>
        </S.PaginationContainer>
      </S.ContentBox>
    </S.ContratosContainer>
  );
}
